import { MenuService } from '@/layout/service/menu.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Pesquisa } from '@/shared/components/pessoa/pesquisa/pesquisa';
import { PessoaService } from '@/shared/services/pessoa.service';

/**
 * Componente principal (layout) para o módulo de Arrecadação.
 * Responsável por renderizar as rotas filhas, gerenciar o menu lateral
 * e controlar a exibição do diálogo de pesquisa de pessoas.
 */
@Component({
    selector: 'app-pre-prestador-content',
    standalone: true,
    imports: [RouterModule, Pesquisa],
    template: `
        <!-- No seu componente de layout principal -->
        <main class="w-full">
            <div>
                <router-outlet></router-outlet>
            </div>
        </main>
        <app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="carregarPessoa($event)"></app-pesquisa>
    `
})
export class PrePrestadorContent implements OnInit {
    /** Controla a visibilidade do diálogo de pesquisa. */
    pesquisarDialog: boolean = false;

    /** Caminho base para as rotas do módulo. */
    rootPath = 'preprestador';

    /** Estrutura do menu de navegação específico para o módulo de Arrecadação. */
    menu = [
        {
            label: 'Home',
            expanded: true,
            items: [
                { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: [this.rootPath] },
                {
                    label: 'Pesquisar Pessoa',
                    icon: 'pi pi-fw pi-search',
                    command: () => {
                        this.pesquisarDialog = true;
                    }
                },
                { label: 'Relatorios', icon: 'pi pi-fw pi-file-import', routerLink: [this.rootPath + '/relatorios'] }
            ]
        }
    ];

    /**
     * Construtor para injetar serviços essenciais.
     * @param menuService - Serviço para gerenciar o estado do menu principal da aplicação.
     * @param router - Serviço do Angular para controle de navegação.
     */
    constructor(
        private menuService: MenuService,
        private router: Router,
        private pessoaService: PessoaService
    ) {}

    /**
     * Hook do ciclo de vida. Executado na inicialização do componente.
     * Define o menu específico deste módulo no serviço de menu global.
     */
    ngOnInit(): void {
        this.menuService.setMenu(this.menu);
    }

    /**
     * Força o recarregamento do componente da rota especificada, mesmo que já esteja ativa.
     * Navega para uma rota temporária e depois retorna à original para forçar a reinicialização.
     * @param rota A rota de destino para recarregar.
     */
    private async executar(rota: string) {
        await this.router.navigateByUrl('/', { skipLocationChange: true });
        await this.router.navigate([rota]);
    }

    /**
     * Callback executado quando uma pessoa é selecionada no diálogo de pesquisa.
     * Salva os dados da pessoa na sessão e recarrega a rota principal do módulo.
     * @param pessoa O objeto da pessoa selecionada.
     */
    carregarPessoa(pessoa?: Pessoa) {
        if (pessoa) {
            this.pessoaService.setPessoa(pessoa);
            this.executar(this.rootPath);
        } else {
            console.error('Registro não encontrado!');
        }
    }
}
